export const SET_GLOBAL = "global";//登录返回的用户信息



// WEBPACK FOOTER //
// ./src/store/mutation-types.js